import React, {PropsWithChildren, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {usePresentationParams} from '../../hooks/usePresentationParams';
import {useTabLock} from '../../hooks/useTabLock';
import {useCaptureRedirectUri} from '../../hooks/useCaptureRedirectUri';
import {setRoomInfoModalAction} from '../../store/actions/roomProtection.actions';
import {roomInfoModalSelector} from '../../store/selectors/roomProtection.selector';
import RoomInfoModal from './room/lobby/modals/RoomInfoModal';

function PresLoaderWrapper({children}: PropsWithChildren<unknown>): JSX.Element {
    const dispatch = useDispatch();
    const {presentationId} = usePresentationParams();
    const infoModal = useSelector(roomInfoModalSelector);
    const {isTaken: isPresTaken} = useTabLock('pres', presentationId);
    // Here rather than in PresWrapper, so short links (SlugWrapper) capture the redirect too
    useCaptureRedirectUri();

    useEffect(() => {
        if (isPresTaken === true) {
            dispatch(setRoomInfoModalAction(true, 'lobby.modals.presAlreadyOpen', 'lobby.modals.presAlreadyOpenDesc'));
        } else if (isPresTaken === false) {
            dispatch(setRoomInfoModalAction(false, '', ''));
        }
    }, [dispatch, isPresTaken]);

    return (
        <>
            {isPresTaken === false && !infoModal.open && children}
            {infoModal.open && <RoomInfoModal />}
        </>
    );
}

export default PresLoaderWrapper;
